export const sharedRoutes = {
  redirectToHome: '/',
  pageNotFound: '/page-not-found',
};

export const ORG_ID_ROUTE_TEMPLATE = ':orgId';
export const ORG_ID_SCOPE_TEMPLATE = '{orgId}';
